// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZIbrE","mobile_progress":"styles_mobile_progress__+krJG"};